import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowContentFollowSliderMiddleProps as Props } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';
import { showRecruitmentPageRecruitmentsForOccupations } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [applications, setApplications] = useState<Recruitment[]>([]);

  useEffect(() => {
    fetchRecruitments();
  }, []);

  useEffect(() => {
    const $slick = $('.js-recruitment-show-content-follow-middle');
    if (!$slick.hasClass('slick-initialized') && applications.length > 0) {
      $slick.slick({
        dots: false,
        arrows: true,
        infinite: applications.length >= 2,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        prevArrow: '<div class="recruitment__show__company__slider--prev"></div>',
        nextArrow: '<div class="recruitment__show__company__slider--next"></div>',
        responsive: [{ breakpoint: 929, settings: { arrows: false } }],
      });
    }
  }, [applications]);


  const fetchRecruitments = async () => {
    try {
      if (!props.recruitmentId) return;
      const response = await showRecruitmentPageRecruitmentsForOccupations(props.recruitmentId);
      setApplications(response.recruitments);
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <Presentation
      {...props}
      applications={applications}
    />
  );
};
